import { koobMarker } from '@koob/map-marker';

import ExportStaticMap from './ExportStaticMap';

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

const POI_MARKER_SIZE = 32;
const HOTEL_MARKER_SIZE = 26;

function hotelDiamondMarker(inkColor) {
  const svg = `<svg width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
    <rect x="6" y="6" width="28" height="28" rx="4" fill="${inkColor}" transform="rotate(45 20 20)" />
    <text x="20" y="25" font-size="14" fill="#FFFFFF" text-anchor="middle" font-weight="bold">H</text>
  </svg>`;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}

export default function ExportDayMap({
  pois,
  hotel,
  theme,
  width = 714,
  height = 140,
  className = 'h-[140px] w-full rounded-lg',
  style,
}) {
  const poiPoints = (pois ?? [])
    .map((poi, index) => ({
      lat: poi?.lat,
      lon: poi?.lon,
      icon: koobMarker('day', {
        label: index + 1,
        filled: true,
        color: theme.primaryColor,
      }),
      markerWidth: POI_MARKER_SIZE,
      markerHeight: POI_MARKER_SIZE * (60 / 45),
    }))
    .filter((p) => p.lat && p.lon);

  const hotelPoint =
    hotel?.lat && hotel?.lon
      ? {
          lat: hotel.lat,
          lon: hotel.lon,
          icon: hotelDiamondMarker(theme.inkColor),
          markerWidth: HOTEL_MARKER_SIZE,
          markerHeight: HOTEL_MARKER_SIZE,
          anchorCenter: true,
        }
      : null;

  const points = [...poiPoints, ...(hotelPoint ? [hotelPoint] : [])];

  if (points.length === 0) return null;

  return (
    <div data-prevent-cut>
      <ExportStaticMap
        points={points}
        apiKey={GOOGLE_MAPS_API_KEY}
        width={width}
        height={height}
        className={className}
        style={style}
      />
    </div>
  );
}
